import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { IModalSectionHeaderProps } from './EditableSectionHeader.types';
import { SvgImage } from '../SvgImage';
import { getAssetPath } from '../../util/images';
import { Text } from '../Text/Text';
import { NoneButton } from '../AttachmentTag/AttachmentTag';

const EditableSectionHeaderIcon = styled(SvgImage)`
  svg path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

const HeaderRightIcon = styled(NoneButton)`
  float: right;
  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

const EditableSectionHeader: React.FC<IModalSectionHeaderProps> = (
  props: IModalSectionHeaderProps
) => {
  const { className, icon, children, onEdit, addMode, testId } = props;
  ReactTooltip.rebuild();

  return (
    <Text fontSize="20px" className={`${className ?? ''}`}>
      {children}
      {!addMode && (
        <HeaderRightIcon
          type="button"
          data-for="modalTooltip"
          data-tip="Edit"
          onClick={() => {
            if (onEdit) {
              onEdit();
            }
          }}
          data-testid={testId ? `${testId}_pen` : 'pen'}
        >
          <EditableSectionHeaderIcon inAssetsPath={getAssetPath(icon)} />
        </HeaderRightIcon>
      )}
    </Text>
  );
};

export default EditableSectionHeader;
